module.exports = __webpack_public_path__ + "img/img_xinshou_6.0d3603e0.png";